import { twJoin } from 'tailwind-merge';

import type { Props as BaseButtonProps } from './BaseButton';
import { BaseButton } from './BaseButton';

export const PrimaryButton = ({ className, ...rest }: BaseButtonProps) => {
  return (
    <BaseButton
      {...rest}
      className={twJoin(
        'text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800',
        className,
      )}
    />
  );
};
